import { render, staticRenderFns } from "./TermsChangeRequest.vue?vue&type=template&id=a9114ab4"
import script from "./TermsChangeRequest.vue?vue&type=script&lang=js"
export * from "./TermsChangeRequest.vue?vue&type=script&lang=js"
import style0 from "./TermsChangeRequest.vue?vue&type=style&index=0&id=a9114ab4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports